<template>
  <b-card>
    <div id="DataTables_Table_1_wrapper" class="dataTables_wrapper dt-bootstrap5 no-footer">
      <div class="card-header pt-1 pb-25">
          <div class="head-label"><h4 class="card-title">Dispute Letters</h4></div>
          <div class="dt-action-buttons text-end">
              <div class="dt-buttons d-inline-flex">
                  <button class="dt-button buttons-collection btn btn-outline-secondary dropdown-toggle" tabindex="0" aria-controls="DataTables_Table_1" type="button" aria-haspopup="true">
                      <span>
                          <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              class="feather feather-external-link font-small-4 me-50"
                          >
                              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                              <polyline points="15 3 21 3 21 9"></polyline>
                              <line x1="10" y1="14" x2="21" y2="3"></line>
                          </svg>
                          Export
                      </span>
                  </button>
              </div>
          </div>
      </div>
      <table class="invoice-table table text-nowrap dataTable no-footer dtr-column" id="DataTables_Table_1" role="grid">
          <thead>
              <tr role="row">
                  <th class="control sorting" tabindex="0" aria-controls="DataTables_Table_1" rowspan="1" colspan="1" aria-label=": activate to sort column ascending" style="display: none;"></th>
                  <th class="sorting sorting_desc" tabindex="0" aria-controls="DataTables_Table_1" rowspan="1" colspan="1" style="width: 46px;" aria-label="#ID: activate to sort column ascending" aria-sort="descending">#ID</th>
                  <th class="sorting" tabindex="0" aria-controls="DataTables_Table_1" rowspan="1" colspan="1" style="width: 42px;" aria-label=": activate to sort column ascending">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trending-up">
                          <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
                          <polyline points="17 6 23 6 23 12"></polyline>
                      </svg>
                  </th>
                  <th class="sorting" tabindex="0" aria-controls="DataTables_Table_1" rowspan="1" colspan="1" style="width: 73px;" aria-label="TOTAL Paid: activate to sort column ascending">TOTAL Paid</th>
                  <th class="text-truncate sorting" tabindex="0" aria-controls="DataTables_Table_1" rowspan="1" colspan="1" style="width: 130px;" aria-label="Issued Date: activate to sort column ascending">Issued Date</th>
                  <th class="cell-fit sorting_disabled" rowspan="1" colspan="1" style="width: 80px;" aria-label="Actions">Actions</th>
              </tr>
          </thead>
          <tbody>
              <tr class="odd">
                  <td class="control" tabindex="0" style="display: none;"></td>
                  <td class="sorting_1"><a class="fw-bolder" href="https://pixinvent.com/demo/vuexy-bootstrap-laravel-admin-template/demo-2/app/invoice/preview"> #5089</a></td>
                  <td>
                      <span
                          data-bs-toggle="tooltip"
                          data-bs-html="true"
                          title=""
                          data-bs-original-title='<span>Sent<br> <span class="fw-bold">Balance:</span> 0<br> <span class="fw-bold">Due Date:</span> 05/09/2019</span>'
                          aria-label='<span>Sent<br> <span class="fw-bold">Balance:</span> 0<br> <span class="fw-bold">Due Date:</span> 05/09/2019</span>'
                      >
                          <div class="avatar avatar-status bg-light-secondary">
                              <span class="avatar-content">
                                  <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="feather feather-send avatar-icon"
                                  >
                                      <line x1="22" y1="2" x2="11" y2="13"></line>
                                      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                                  </svg>
                              </span>
                          </div>
                      </span>
                  </td>
                  <td>$3077</td>
                  <td>02 May 2019</td>
                  <td>
                      <div class="d-flex align-items-center col-actions">
                          <a class="me-1" href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="" data-bs-original-title="Send Mail" aria-label="Send Mail">
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="feather feather-send font-medium-2 text-body"
                              >
                                  <line x1="22" y1="2" x2="11" y2="13"></line>
                                  <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                              </svg>
                          </a>
                          <a
                              class="me-1"
                              href="https://pixinvent.com/demo/vuexy-bootstrap-laravel-admin-template/demo-2/app/invoice/preview"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title=""
                              data-bs-original-title="Preview Invoice"
                              aria-label="Preview Invoice"
                          >
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="feather feather-eye font-medium-2 text-body"
                              >
                                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                  <circle cx="12" cy="12" r="3"></circle>
                              </svg>
                          </a>
                          <a href="javascript:void(0)" data-bs-toggle="tooltip" data-bs-placement="top" title="" data-bs-original-title="Download" aria-label="Download">
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="feather feather-download font-medium-2 text-body"
                              >
                                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                  <polyline points="7 10 12 15 17 10"></polyline>
                                  <line x1="12" y1="15" x2="12" y2="3"></line>
                              </svg>
                          </a>
                      </div>
                  </td>
              </tr>
              <tr class="even">
                  <td class="control" tabindex="0" style="display: none;"></td>
                  <td class="sorting_1"><a class="fw-bolder" href="https://pixinvent.com/demo/vuexy-bootstrap-laravel-admin-template/demo-2/app/invoice/preview"> #5041</a></td>
                  <td>
                      <span
                          data-bs-toggle="tooltip"
                          data-bs-html="true"
                          title=""
                          data-bs-original-title='<span>Sent<br> <span class="fw-bold">Balance:</span> 0<br> <span class="fw-bold">Due Date:</span> 11/19/2019</span>'
                          aria-label='<span>Sent<br> <span class="fw-bold">Balance:</span> 0<br> <span class="fw-bold">Due Date:</span> 11/19/2019</span>'
                      >
                          <div class="avatar avatar-status bg-light-secondary">
                              <span class="avatar-content">
                                  <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="feather feather-send avatar-icon"
                                  >
                                      <line x1="22" y1="2" x2="11" y2="13"></line>
                                      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                                  </svg>
                              </span>
                          </div>
                      </span>
                  </td>
                  <td>$2230</td>
                  <td>01 Feb 2020</td>
                  <td>
                      <div class="d-flex align-items-center col-actions">
                          <a class="me-1" href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="" data-bs-original-title="Send Mail" aria-label="Send Mail">
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="feather feather-send font-medium-2 text-body"
                              >
                                  <line x1="22" y1="2" x2="11" y2="13"></line>
                                  <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                              </svg>
                          </a>
                          <a
                              class="me-1"
                              href="https://pixinvent.com/demo/vuexy-bootstrap-laravel-admin-template/demo-2/app/invoice/preview"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title=""
                              data-bs-original-title="Preview Invoice"
                              aria-label="Preview Invoice"
                          >
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="feather feather-eye font-medium-2 text-body"
                              >
                                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                  <circle cx="12" cy="12" r="3"></circle>
                              </svg>
                          </a>
                          <a href="javascript:void(0)" data-bs-toggle="tooltip" data-bs-placement="top" title="" data-bs-original-title="Download" aria-label="Download">
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="feather feather-download font-medium-2 text-body"
                              >
                                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                  <polyline points="7 10 12 15 17 10"></polyline>
                                  <line x1="12" y1="15" x2="12" y2="3"></line>
                              </svg>
                          </a>
                      </div>
                  </td>
              </tr>
              <tr class="odd">
                  <td class="control" tabindex="0" style="display: none;"></td>
                  <td class="sorting_1"><a class="fw-bolder" href="https://pixinvent.com/demo/vuexy-bootstrap-laravel-admin-template/demo-2/app/invoice/preview"> #5027</a></td>
                  <td>
                      <span
                          data-bs-toggle="tooltip"
                          data-bs-html="true"
                          title=""
                          data-bs-original-title='<span>Partial Payment<br> <span class="fw-bold">Balance:</span> 0<br> <span class="fw-bold">Due Date:</span> 09/25/2019</span>'
                          aria-label='<span>Partial Payment<br> <span class="fw-bold">Balance:</span> 0<br> <span class="fw-bold">Due Date:</span> 09/25/2019</span>'
                      >
                          <div class="avatar avatar-status bg-light-warning">
                              <span class="avatar-content">
                                  <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="feather feather-pie-chart avatar-icon"
                                  >
                                      <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
                                      <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
                                  </svg>
                              </span>
                          </div>
                      </span>
                  </td>
                  <td>$2787</td>
                  <td>28 Sep 2019</td>
                  <td>
                      <div class="d-flex align-items-center col-actions">
                          <a class="me-1" href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="" data-bs-original-title="Send Mail" aria-label="Send Mail">
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="feather feather-send font-medium-2 text-body"
                              >
                                  <line x1="22" y1="2" x2="11" y2="13"></line>
                                  <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                              </svg>
                          </a>
                          <a
                              class="me-1"
                              href="https://pixinvent.com/demo/vuexy-bootstrap-laravel-admin-template/demo-2/app/invoice/preview"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title=""
                              data-bs-original-title="Preview Invoice"
                              aria-label="Preview Invoice"
                          >
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="feather feather-eye font-medium-2 text-body"
                              >
                                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                  <circle cx="12" cy="12" r="3"></circle>
                              </svg>
                          </a>
                          <a href="javascript:void(0)" data-bs-toggle="tooltip" data-bs-placement="top" title="" data-bs-original-title="Download" aria-label="Download">
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="feather feather-download font-medium-2 text-body"
                              >
                                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                  <polyline points="7 10 12 15 17 10"></polyline>
                                  <line x1="12" y1="15" x2="12" y2="3"></line>
                              </svg>
                          </a>
                      </div>
                  </td>
              </tr>
              <tr class="even">
                  <td class="control" tabindex="0" style="display: none;"></td>
                  <td class="sorting_1"><a class="fw-bolder" href="https://pixinvent.com/demo/vuexy-bootstrap-laravel-admin-template/demo-2/app/invoice/preview"> #5024</a></td>
                  <td>
                      <span
                          data-bs-toggle="tooltip"
                          data-bs-html="true"
                          title=""
                          data-bs-original-title='<span>Partial Payment<br> <span class="fw-bold">Balance:</span> -$202<br> <span class="fw-bold">Due Date:</span> 08/02/2019</span>'
                          aria-label='<span>Partial Payment<br> <span class="fw-bold">Balance:</span> -$202<br> <span class="fw-bold">Due Date:</span> 08/02/2019</span>'
                      >
                          <div class="avatar avatar-status bg-light-warning">
                              <span class="avatar-content">
                                  <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="feather feather-pie-chart avatar-icon"
                                  >
                                      <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
                                      <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
                                  </svg>
                              </span>
                          </div>
                      </span>
                  </td>
                  <td>$5285</td>
                  <td>30 Jun 2019</td>
                  <td>
                      <div class="d-flex align-items-center col-actions">
                          <a class="me-1" href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="" data-bs-original-title="Send Mail" aria-label="Send Mail">
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="feather feather-send font-medium-2 text-body"
                              >
                                  <line x1="22" y1="2" x2="11" y2="13"></line>
                                  <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                              </svg>
                          </a>
                          <a
                              class="me-1"
                              href="https://pixinvent.com/demo/vuexy-bootstrap-laravel-admin-template/demo-2/app/invoice/preview"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title=""
                              data-bs-original-title="Preview Invoice"
                              aria-label="Preview Invoice"
                          >
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="feather feather-eye font-medium-2 text-body"
                              >
                                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                  <circle cx="12" cy="12" r="3"></circle>
                              </svg>
                          </a>
                          <a href="javascript:void(0)" data-bs-toggle="tooltip" data-bs-placement="top" title="" data-bs-original-title="Download" aria-label="Download">
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="feather feather-download font-medium-2 text-body"
                              >
                                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                  <polyline points="7 10 12 15 17 10"></polyline>
                                  <line x1="12" y1="15" x2="12" y2="3"></line>
                              </svg>
                          </a>
                      </div>
                  </td>
              </tr>
              <tr class="odd">
                  <td class="control" tabindex="0" style="display: none;"></td>
                  <td class="sorting_1"><a class="fw-bolder" href="https://pixinvent.com/demo/vuexy-bootstrap-laravel-admin-template/demo-2/app/invoice/preview"> #5020</a></td>
                  <td>
                      <span
                          data-bs-toggle="tooltip"
                          data-bs-html="true"
                          title=""
                          data-bs-original-title='<span>Downloaded<br> <span class="fw-bold">Balance:</span> 0<br> <span class="fw-bold">Due Date:</span> 12/15/2019</span>'
                          aria-label='<span>Downloaded<br> <span class="fw-bold">Balance:</span> 0<br> <span class="fw-bold">Due Date:</span> 12/15/2019</span>'
                      >
                          <div class="avatar avatar-status bg-light-info">
                              <span class="avatar-content">
                                  <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="feather feather-arrow-down-circle avatar-icon"
                                  >
                                      <circle cx="12" cy="12" r="10"></circle>
                                      <polyline points="8 12 12 16 16 12"></polyline>
                                      <line x1="12" y1="8" x2="12" y2="16"></line>
                                  </svg>
                              </span>
                          </div>
                      </span>
                  </td>
                  <td>$5219</td>
                  <td>17 Jul 2019</td>
                  <td>
                      <div class="d-flex align-items-center col-actions">
                          <a class="me-1" href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="" data-bs-original-title="Send Mail" aria-label="Send Mail">
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="feather feather-send font-medium-2 text-body"
                              >
                                  <line x1="22" y1="2" x2="11" y2="13"></line>
                                  <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                              </svg>
                          </a>
                          <a
                              class="me-1"
                              href="https://pixinvent.com/demo/vuexy-bootstrap-laravel-admin-template/demo-2/app/invoice/preview"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title=""
                              data-bs-original-title="Preview Invoice"
                              aria-label="Preview Invoice"
                          >
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="feather feather-eye font-medium-2 text-body"
                              >
                                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                  <circle cx="12" cy="12" r="3"></circle>
                              </svg>
                          </a>
                          <a href="javascript:void(0)" data-bs-toggle="tooltip" data-bs-placement="top" title="" data-bs-original-title="Download" aria-label="Download">
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="feather feather-download font-medium-2 text-body"
                              >
                                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                  <polyline points="7 10 12 15 17 10"></polyline>
                                  <line x1="12" y1="15" x2="12" y2="3"></line>
                              </svg>
                          </a>
                      </div>
                  </td>
              </tr>
              <tr class="even">
                  <td class="control" tabindex="0" style="display: none;"></td>
                  <td class="sorting_1"><a class="fw-bolder" href="https://pixinvent.com/demo/vuexy-bootstrap-laravel-admin-template/demo-2/app/invoice/preview"> #4995</a></td>
                  <td>
                      <span
                          data-bs-toggle="tooltip"
                          data-bs-html="true"
                          title=""
                          data-bs-original-title='<span>Partial Payment<br> <span class="fw-bold">Balance:</span> 0<br> <span class="fw-bold">Due Date:</span> 06/09/2019</span>'
                          aria-label='<span>Partial Payment<br> <span class="fw-bold">Balance:</span> 0<br> <span class="fw-bold">Due Date:</span> 06/09/2019</span>'
                      >
                          <div class="avatar avatar-status bg-light-warning">
                              <span class="avatar-content">
                                  <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="feather feather-pie-chart avatar-icon"
                                  >
                                      <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
                                      <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
                                  </svg>
                              </span>
                          </div>
                      </span>
                  </td>
                  <td>$3313</td>
                  <td>21 Aug 2019</td>
                  <td>
                      <div class="d-flex align-items-center col-actions">
                          <a class="me-1" href="#" data-bs-toggle="tooltip" data-bs-placement="top" title="" data-bs-original-title="Send Mail" aria-label="Send Mail">
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="feather feather-send font-medium-2 text-body"
                              >
                                  <line x1="22" y1="2" x2="11" y2="13"></line>
                                  <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                              </svg>
                          </a>
                          <a
                              class="me-1"
                              href="https://pixinvent.com/demo/vuexy-bootstrap-laravel-admin-template/demo-2/app/invoice/preview"
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title=""
                              data-bs-original-title="Preview Invoice"
                              aria-label="Preview Invoice"
                          >
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="feather feather-eye font-medium-2 text-body"
                              >
                                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                  <circle cx="12" cy="12" r="3"></circle>
                              </svg>
                          </a>
                          <a href="javascript:void(0)" data-bs-toggle="tooltip" data-bs-placement="top" title="" data-bs-original-title="Download" aria-label="Download">
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="feather feather-download font-medium-2 text-body"
                              >
                                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                  <polyline points="7 10 12 15 17 10"></polyline>
                                  <line x1="12" y1="15" x2="12" y2="3"></line>
                              </svg>
                          </a>
                      </div>
                  </td>
              </tr>
          </tbody>
      </table>
  </div>

  </b-card>
</template>
<script>
import {
  BCard, BButton, BAvatar, BRow, BCol,
} from 'bootstrap-vue-3'
export default{
  name:'UserInvoiceView',
  components: {
    BCard, BButton, BRow, BCol, BAvatar,
  },
}
</script>
